const TIPOS_DOCUMENTO = {
  CI: 'Cédula de Identidad',
  RU: 'RUC'
};

const CATEGORIAS = {
  MI: 'MICRO',
  PE: 'PEQUEÑA',
  ME: 'MEDIANA'
};

const ESTADOS = {
  A: 'APROBADO',
  P: 'PENDIENTE'
};

const ES_INFO_MESSAGE =
  'El Directorio de Servicios para Inversionistas es un buscador para facilitar al inversor extranjero la instalación en el Paraguay. Encuentre aquí empresas que brindan servicios en Paraguay y cómo contactarlos.';

const EN_INFO_MESSAGE =
  'The Investor Services Directory is a search engine to facilitate the installation of foreign investors in Paraguay. You can find here information about companies and suppliers that provide services in Paraguay and how to contact them.';

const PT_INFO_MESSAGE =
  'O Diretório de Serviços para Investidores é uma ferramenta de busca para facilitar a instalação de investidores estrangeiros no Paraguai. Encontre aqui empresas que prestam serviços no Paraguai e como contatá-las.';

const ES_WARNING_MESSAGE =
  'OBSERVACIÓN: Los datos expuestos en este buscador se tratan exclusivamente de proveedores de servicios inscriptos en el Registro de Prestadores de Servicios (REPSE) del Ministerio de Industria y Comercio de Paraguay (MIC). ' +
  'El Ministerio de Industria y Comercio se limita a presentar el listado de las empresas formalmente registradas en el REPSE a través de este Directorio y en ningún caso es responsable de los acuerdos de prestación de servicios que surjan en el contacto entre las partes.';

const EN_WARNING_MESSAGE = 
  'OBSERVATION: The data exposed in this search engine is exclusively about service providers registered in the Registry of Service Providers (REPSE) of the Ministry of Industry and Commerce of Paraguay (MIC). ' +
  'The Ministry of Industry and Commerce is limited to presenting the list of companies formally registered in REPSE through this Directory and, under no circumstances, is responsible for the service provision agreements that arise in the contact between the parties.';

const PT_WARNING_MESSAGE =
  'OBSERVAÇÃO: Os dados expostos neste mecanismo de busca referem-se exclusivamente aos prestadores de serviços cadastrados no Cadastro de Prestadores de Serviços (REPSE) do Ministério da Indústria e Comércio do Paraguai (MIC). ' +
  'O Ministério da Indústria e Comércio se limita a apresentar a lista de empresas formalmente registradas no Repše através deste Diretório e em nenhum caso é responsável pelos contratos de prestação de serviços que surgem no contato entre as partes.';

export { ES_INFO_MESSAGE, EN_INFO_MESSAGE, PT_INFO_MESSAGE, ES_WARNING_MESSAGE, EN_WARNING_MESSAGE, PT_WARNING_MESSAGE, TIPOS_DOCUMENTO, CATEGORIAS, ESTADOS };
